import { render, staticRenderFns } from "./Form-login.vue?vue&type=template&id=508b485a&"
import script from "./Form-login.vue?vue&type=script&lang=js&"
export * from "./Form-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports